import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserAgentService } from '@app/common/userAgent.service';
import { notificationStoreActions, relationshipStoreActions, RootStoreState } from '@app/root-store';
import { select, Store } from '@ngrx/store';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as notificationSelectors from '../../../../root-store/notification-store/notification.selector';
import * as selectors from '../../../../root-store/relationship-store/relationship.selector';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { selectItems, selectMySuggestions } from '../../../../root-store/relationship-store/relationship.selector';
import { MatDialog } from '@angular/material/dialog';
import { MutualConnectionComponent } from '../mutual-connection/mutual-connection.component';
import { SharedConfirmationDialogComponent } from '../../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { UserConnectionService } from '@app/shared/services/user_connection/user-connection.service';
import { ConnectUserComponent } from '../../connect-user/connect-user.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'network-suggestions',
  templateUrl: './network-suggestions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkSuggestionsComponent implements OnInit, OnDestroy {
  @Input() connectionRequestsData = [];
  @Input() isProfessional_Relationship;
  @Input() fromHome;

  @Output() acceptRequestEmit = new EventEmitter<any>();
  @Output() rejectRequestEmit = new EventEmitter<any>();

  relationshipRequestsTitle: string = 'Network Requests';
  clientRequestTtile: string = 'Client Requests';
  TotalAllinvitesRelationShip$;
  showSubItems = [];
  user;
  connectionCount;
  relationships: any = [];
  acceptedNotification: any[] = [];
  declinedNotification: any[] = [];
  screenHeight: number;
  screenWidth: number;
  getRequestRelationshipData$;
  isOffice: boolean = false;
  userAgent: any;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  mySuggestions$: Observable<any[]>;
  mySuggestions: any = [];
  mySuggestionIds: any = [];
  helpCenterLink = 'https://help.kinnect.us/content/about-network-suggestions';
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 1000,
    navText: ['', ''],
    nav: false,
  };
  myRelationship$: Observable<any[]>;
  myRelationship: any = [];
  constructor(
    private store: Store,
    private router: Router,
    private store$: Store<RootStoreState.State>,
    private cd: ChangeDetectorRef,
    private userAgentService: UserAgentService,
    private _dialog: MatDialog,
    private UserConnection: UserConnectionService
  ) {
    this.userAgent = this.userAgentService.getUserAgents();
    this.myRelationship$ = this.store.select(selectItems);
    if (this.connectionRequestsData) {
      this.showSubItems = this.connectionRequestsData.map((i) => false);
    }

    if (this.router.url.includes('office-relationship/my-relationships') || this.router.url.includes('office-relationship/my-prof-relationships')) {
      this.isOffice = true;
    } else {
      this.isOffice = false;
    }
  }

  ngOnInit() {
    this.mySuggestions = 0;
    this.cd.detectChanges();
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.mySuggestions$ = this.store.select(selectMySuggestions);
    this.subscription.add(
      this.mySuggestions$.subscribe((data) => {
        this.mySuggestions = data.length;
        this.mySuggestionIds = data.map((item) => item.id).filter((id) => id !== null && id !== undefined);
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.myRelationship$.subscribe((data) => {
        this.myRelationship = data;
      })
    );
  }
  mutualConnection(user) {
    const sharedDialogRef = this._dialog.open(MutualConnectionComponent, {
      width: '400px',
      data: user,
    });
  }
  checkConnectionData(): boolean {
    if (this.connectionRequestsData == null) {
      return true;
    }

    if (this.connectionRequestsData.length) {
      return true;
    } else {
      return false;
    }
  }

  checkConnectionCount(): boolean {
    if (this.connectionRequestsData && this.connectionRequestsData.length) {
      this.connectionCount = this.connectionRequestsData.filter(
        (connection) => connection.to_user_id == this.user?.id && connection.connection_status == 'pending'
      );
      return this.connectionCount.length ? true : false;
    } else {
      return false;
    }
  }

  toggleSettings(id) {
    this.showSubItems[id] = !this.showSubItems[id];

    const itemClicked = this.showSubItems.filter((item) => {
      return item === true;
    });
    if (itemClicked.length > 1) {
      this.showSubItems = this.connectionRequestsData.map((i) => false);
      this.showSubItems[id] = !this.showSubItems[id];
    }
  }

  closeSettings(id) {
    this.showSubItems[id] = false;
  }

  acceptRequest(params: any, user): void {
    const modalRef = this._dialog.open(ConnectUserComponent, {
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
      data: {
        fromAddVault: true,
        selectedUser: user,
        requestForAddedUserData: true,
      },
    });

    this.subscription.add(
      modalRef.afterClosed().subscribe(
        () => {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());
        },
        (error) => {
          console.error('Error closing the modal:', error);
        }
      )
    );
  }
  removeSuggestions(userOrIds: any) {
    const userIds = Array.isArray(userOrIds) ? userOrIds : [userOrIds.id];

    const sharedDialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: userIds.length > 1 ? `Remove All Suggestions` : `Remove Suggestion`,
        materialIcon: userIds.length > 1 ? 'remove-info' : 'info_outline',
        text: userIds.length > 1 ? `Are you sure you want to remove all network suggestions?` : `Are you sure you want to remove this suggestion?`,
        proceedTitle: 'Remove',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.UserConnection.mySuggestionRemove(userIds).subscribe((data) => {
              this.store$.dispatch(new relationshipStoreActions.AllRelationships());
              this.cd.markForCheck(); // Trigger change detection
            })
          );
        }
      })
    );
  }

  viewProfile(connection) {
    this.router.navigate([`/profile/${connection.connection_user_id}`]);
  }

  markAsRead(notification, notificationState) {
    if (!notification.is_read) {
      this.store$.dispatch(new notificationStoreActions.MarkAsReadAction(notification.id));

      // Home
      if (this.router.url.includes('home')) {
        if (notificationState == 'accepted') {
          this.getAcceptedNotification('home');
        } else {
          this.getDeclinedNotification('home');
        }
      }
      // Professional
      else if (this.router.url.includes('relationship/prof-relationships')) {
        if (notificationState == 'accepted') {
          this.getAcceptedNotification('professional');
        } else {
          this.getDeclinedNotification('professional');
        }
      }
      // Office
      else if (this.router.url.includes('office-relationship/my-relationships')) {
        if (notificationState == 'accepted') {
          this.getAcceptedNotification('office-clients');
        } else {
          this.getDeclinedNotification('office-clients');
        }
      }
      // Personal
      else if (this.router.url.includes('relationship/my-relationships') || this.router.url.includes('network/my-network')) {
        if (notificationState == 'accepted') {
          this.getAcceptedNotification('personal');
        } else {
          this.getDeclinedNotification('personal');
        }
      }

      // Office Professional
      else if (this.router.url.includes('office-relationship/my-prof-relationships')) {
        if (notificationState == 'accepted') {
          this.getAcceptedNotification('office-professional');
        } else {
          this.getDeclinedNotification('office-professional');
        }
      }
    }
  }

  getAcceptedNotification(calledAt) {
    this.subscription.add(
      this.store.pipe(select(notificationSelectors.getAcceptedNotifications(calledAt))).subscribe((response) => {
        if (response) {
          this.acceptedNotification = [...response];
        } else {
          this.acceptedNotification = [];
        }
        this.cd.detectChanges();
      })
    );
  }

  getDeclinedNotification(calledAt) {
    this.subscription.add(
      this.store.pipe(select(notificationSelectors.getDeclinedNotifications(calledAt))).subscribe((response) => {
        if (response) {
          this.declinedNotification = [...response];
        } else {
          this.declinedNotification = [];
        }
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
